/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTTogglePassword } from './toggle-password';
export type {
	KTTogglePasswordConfigInterface,
	KTTogglePasswordInterface,
} from './types';
